export default __webpack_public_path__ + "_/shared_modules/common-images/loantype-individual-e72387798f175e76207cbb7848d04248.svg";